export default __webpack_public_path__ + "static/BAND-6dd8c2acf59290861958ed69efa9426c.jpg";